<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">{{ rowTitle }}</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/lawyerReq">اطلب محاميك</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{ rowTitle }}</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <LawyerReqForm v-if="!mainLoading && checkAccess('lawyer_requests_update')" 
              :cardTitle="rowTitle" 
              :dataRow="row" 
              :propertyRow="propertyRow" 
              :statusObject="statusChioces"
            />
            <LawyerReqView v-if="!mainLoading && !checkAccess('lawyer_requests_update')" 
              :cardTitle="rowTitle" 
              :dataRow="row" 
              :propertyRow="propertyRow" 
              :statusObject="statusChioces"
            />
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <div class="card card-warning card-outline mb-4 mt-4">
              <div class="card-header"><div class="card-title">المحادثة بين العميل والمحامي</div></div>
              <div class="card-body">
                <div
                  v-for="(r, indx) in replies"
                  :key="r.id"
                  class="row lawyer-reply p-3 mb-3"
                  :class="r.fromAdmin ? 'lawyer-reply--lawyer' : 'lawyer-reply--client'"
                >
                  <div class="col-12">
                    <div class="row">
                      <div class="col text-start">
                        <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
                          <span class="lawyer-reply__sender">
                            <i :class="r.fromAdmin ? 'bi bi-briefcase-fill' : 'bi bi-person-fill'" aria-hidden="true"></i>
                            {{ r.fromAdmin ? 'رد المحامي' : 'رد العميل' }}
                          </span>
                          <strong>{{ r.fromAdmin ? (r.Admin?.name || 'المحامي') : (r.User?.name || row?.User?.name || 'العميل') }}</strong>
                        </div>
                      </div>
                      <div class="col text-end">
                        <button type="button" v-if="checkAccess('lawyer_requests_delete')" class="btn btn-danger btn-sm" @click="deleteReply(r.id, indx)"><i class="bi bi-trash"></i></button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="lawyer-reply__text">{{ r.reply }}</div>
                  </div>
                  <div v-if="replyAttachments(r).length" class="col-12 mb-3">
                    <div class="form-label">المرفقات:</div>
                    <div class="d-flex flex-wrap gap-3">
                      <a
                        v-for="(attachment, attachmentIndex) in replyAttachments(r)"
                        :key="attachmentIndex"
                        :href="attachmentUrl(attachment)"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="d-inline-block text-center text-break"
                      >
                        <img
                          v-if="isImageAttachment(attachment)"
                          :src="attachmentUrl(attachment)"
                          :alt="`مرفق الرد ${attachmentIndex + 1}`"
                          class="img-thumbnail d-block mb-1"
                          style="width: 150px; height: 110px; object-fit: cover"
                        >
                        <i v-else class="bi bi-file-earmark-pdf fs-2 d-block" aria-hidden="true"></i>
                        <span class="small d-block" style="max-width: 150px">{{ attachmentName(attachment) }}</span>
                      </a>
                    </div>
                  </div>
                </div>

                <div v-if="checkAccess('lawyer_requests_update')" class="row">
                  <div class="col">
                    <form action="" @submit.prevent="subimtReply()">
                      <div class="form-group mb-3">
                        <label for="" class="form-label">رد المحامي:</label>
                        <textarea v-model="reply" class="form-control" rows="5"></textarea>
                      </div>
                      <div class="form-group text-end">
                        <input v-if="!replyLoading" type="submit" class="btn btn-warning" value="إرسال رد">
                        <loader v-if="replyLoading" />
                      </div>
                    </form>
                  </div>
                </div>
                <div>
                  <AdminNotesPanel
                    v-if="!mainLoading"
                    modelName="LawyerRequests"
                    :recordId="id"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast, checkAccess } from '@/helpers/tools';
import LawyerReqForm from './form.vue';
import LawyerReqView from './view.vue';
import AdminNotesPanel from '../admin_notes/adminNotesPanel.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'LawyerReqUpdate',
  components: {
    LawyerReqForm, LawyerReqView, AdminNotesPanel
  },
  computed: {
    ...mapGetters(['MEDIA_URL']),
  },
  data(){
    return {
      id: this.$route.params.id,
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rowTitle: 'تعديل الطلب ',
      row: null,
      statusChioces: {},
      replyLoading: false,
      replies: [],
      reply: '',
      propertyRow: null,
    }
  },
  methods: {
    checkAccess,
    attachmentPath(attachment){
      return typeof attachment === 'string' ? attachment : attachment?.path || '';
    },
    replyAttachments(reply){
      return Array.isArray(reply.attachments)
        ? reply.attachments.filter(attachment => this.attachmentPath(attachment))
        : [];
    },
    attachmentUrl(attachment){
      return `${this.MEDIA_URL}${this.attachmentPath(attachment).replace(/^\/+/, '')}`;
    },
    attachmentName(attachment){
      return this.attachmentPath(attachment).split('/').pop();
    },
    isImageAttachment(attachment){
      const extension = typeof attachment === 'string'
        ? attachment.split('.').pop()
        : attachment.extention || attachment.path?.split('.').pop();
      return ['png', 'jpg', 'jpeg', 'webp', 'pmb'].includes(extension?.toLowerCase());
    },
    getRowData(){
      this.$http.get(`/api/admin/lawyerReq/retrieve/${this.id}`).then(({data}) => {
        this.rowTitle = this.rowTitle + data.row.name;
        this.row = data.row;
        this.propertyRow = data.propertyRow;
        this.replies = data.row.LawyerReplies;
        this.statusChioces = data.statusChioces;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async deleteReply(id, index){
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد حذف الرد ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });
      
      if (deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/lawyerReq/reply/delete/${id}`).then(({data}) => {
          let buffer = this.replies;
          buffer.splice(index, 1);
          this.replies = buffer;
          // this.rows.splice(index, 1);
          toast('تم الحذف بنجاح', 'success');
        }).catch(err => {
          toast('غير قادر على الحذف');
        });
      }
    },
    subimtReply(){
      this.replyLoading = true;
      this.$http.post(`/api/admin/lawyerReq/reply/${this.id}`, {
        reply: this.reply,
      }).then(({data}) => {
        this.replies.push(data.row);
        this.reply = '';
        this.replyLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.replyLoading = false;
      });
    }
  },
  created(){
    this.getRowData();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
</script>

<style scoped>
.lawyer-reply {
  --reply-text: #173b29;
  --reply-link: #166a43;
  width: fit-content;
  min-width: min(100%, 320px);
  max-width: 88%;
  border: 1px solid #bbdfc9;
  border-inline-start: 5px solid #16834d;
  border-radius: 0.75rem;
  background: #f0faf3;
  color: var(--reply-text);
  margin-inline-end: auto;
}

.lawyer-reply--lawyer {
  --reply-text: #1d355b;
  --reply-link: #245eb4;
  border-color: #b9cef1;
  border-inline-start-color: #2563c7;
  background: #eff5ff;
  margin-inline-start: auto;
  margin-inline-end: 0;
}

.lawyer-reply__sender {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.25rem 0.65rem;
  border-radius: 0.4rem;
  background: #d8f0e0;
  color: #0c6037;
  font-weight: 700;
}

.lawyer-reply--lawyer .lawyer-reply__sender {
  background: #dbe9ff;
  color: #194f9e;
}

.lawyer-reply__text {
  color: var(--reply-text);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.lawyer-reply strong,
.lawyer-reply .form-label { color: var(--reply-text); }

.lawyer-reply a { color: var(--reply-link); }
.lawyer-reply a:hover,
.lawyer-reply a:focus-visible { color: var(--reply-link); text-decoration: underline; }

:global(html[data-bs-theme="dark"] .lawyer-reply--client) {
  --reply-text: #e4f7e9;
  --reply-link: #a7e9bc;
  background: #193727;
  border-color: #4a8560;
}

:global(html[data-bs-theme="dark"] .lawyer-reply--lawyer) {
  --reply-text: #e8f1ff;
  --reply-link: #b6d5ff;
  background: #1d304f;
  border-color: #5b80b6;
}

:global(html[data-bs-theme="dark"] .lawyer-reply--client .lawyer-reply__sender) {
  background: #2c5b3d;
  color: #e4f7e9;
}

:global(html[data-bs-theme="dark"] .lawyer-reply--lawyer .lawyer-reply__sender) {
  background: #35527c;
  color: #e8f1ff;
}
</style>
